export default function SubsheetColumnValidator(values) {
  if (!values.options.sub_list_id) {
    window.appStore.notificationStore.showNotification(
      "Click Revise to Add/Edit Subsheet Fields",
      "error"
    );
    return false;
  }
  return true;
}
